const Spinner = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 50 50"
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginRight: '10px' }}
  >
    <circle
      cx="25"
      cy="25"
      r="20"
      fill="none"
      stroke="#ffffff"
      strokeWidth="4"
      strokeLinecap="round"
      strokeDasharray="90,150"
      strokeDashoffset="0"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        from="0 25 25"
        to="360 25 25"
        dur="1s"
        repeatCount="indefinite"
      />
    </circle>
  </svg>
);


export default Spinner;